import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconScreenRotationStyle0 = cosmosIconCss;

const CosmosIconScreenRotation$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconScreenRotation extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '505ec0d86b6be0fa6219e3d06881c3fa0ab4005f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'a09b2559fdf34143fa14ee445cad8f2e85fbffc6', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '5b51c3270060cebb14f630bbb1329cc508370eaf', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.26 6h1.11a.3.3 0 0 1 .23.49l-1.86 2.23a.29.29 0 0 1-.46 0l-1.86-2.23a.3.3 0 0 1 .23-.49h1.11a2.2 2.2 0 0 0-2.37-2.5.39.39 0 0 1-.37-.4v-.69a.41.41 0 0 1 .42-.41c2.5.15 3.82 1.55 3.82 4ZM4.5 14.5h-1v-11h7v4a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V15a.5.5 0 0 0-.5-.5Zm2.5-4a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-12a.5.5 0 0 1-.5-.5v-8Zm11.5 1h-10v6h10v-6Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconScreenRotationStyle0; }
}, [1, "cosmos-icon-screen-rotation", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-screen-rotation"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-screen-rotation":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconScreenRotation$1);
            }
            break;
    } });
}

const CosmosIconScreenRotation = CosmosIconScreenRotation$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconScreenRotation, defineCustomElement };
